export const NPCInteractableEventTypes = {
  OnHover: "interactableonnpchover",
  OnInteract: "interactableonnpcinteract",
  OnOut: "interactableonnpcout",
  OnSpawn: "interactableonnpcspawn",
};
